<template>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" v-model="activeTab" >

        <vs-tab v-for="tab in tabsByRule" :key="tab.label"
            icon-pack="feather" :icon="`icon-${tab.icon}`"
            :label="!isSmallerScreen ? tab.label : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                <component :is="tab.component" />
            </div>
        </vs-tab>

</vs-tabs>
</template>

<script>
import { addTawkEvent } from '@/globalComponents.js'

import UserInfo from '@/components/account/UserInfo'
import ChangePassword from '@/components/account/ChangePassword'
import CompanyInfo from '@/components/account/CompanyInfo'
import Employees from '@/components/account/Employees'
import Fiscal from '@/components/account/Fiscal'
import DeliverySettings from '@/components/delivery/DeliverySettings'

export default {
    props : ['tab'],

    components : {
        DeliverySettings,
        UserInfo,
        ChangePassword,
        CompanyInfo,
        Employees,
        Fiscal
    },

    watch: {
        activeTab (val) {
            addTawkEvent(`Alterou de aba - ${this.tabs[val].label}`);
        }
    },

    data () {
        return {
            activeTab : 0,
            tabs: [
                { role: 2, icon: 'user', label: 'Pessoal', component: 'user-info' },
                { role: 2, icon: 'lock', label: 'Alterar senha', component: 'change-password' },
                { role: 0, icon: 'home', label: 'Empresa', component: 'company-info' },
                { role: 0, icon: 'clipboard', label: 'Fiscal', component: 'fiscal' },
                { role: 0, icon: 'users', label: 'Colaboradores', component: 'employees' },
                { role: 1, icon: 'users', label: 'Delivery', component: 'delivery-settings' },
            ]
        }
    },

    created () {
        this.activeTab = this.tab
    },

    computed: {
        tabsByRule () {
            console.log(this.$store.state.AppActiveUser.role);
            return this.tabs.filter(t => t.role >= this.$store.state.AppActiveUser.role);
        },
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        }
    },
}

</script>